import { render, staticRenderFns } from "./BaseHeaderNavigationItem.vue?vue&type=template&id=5f13225e&"
import script from "./BaseHeaderNavigationItem.vue?vue&type=script&lang=ts&"
export * from "./BaseHeaderNavigationItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports